/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unsavedchanges_Title1Inputs */

const en_common_unsavedchanges_title1 = /** @type {(inputs: Common_Unsavedchanges_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsaved changes`)
};

/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Common_Unsavedchanges_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_unsavedchanges_title1 = /** @type {((inputs?: Common_Unsavedchanges_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unsavedchanges_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_unsavedchanges_title1(inputs)
});
export { common_unsavedchanges_title1 as "common_unsavedChanges_title" }